import { Theme } from "../types/types";

export const getPathStyles = (theme: Theme) => ({
  color: theme.text,
  fontSize: "18px",
  fontWeight: 100 as const,
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap" as const,
  gap: "4px",
});

export const getGridItemStyles = (theme: Theme, isSelected: boolean) => ({
  display: "inline-block",
  textAlign: "center" as const,
  width: "80px",
  margin: "12px",
  padding: "8px",
  borderRadius: "8px",
  cursor: "pointer",
  backgroundColor: isSelected ? theme.selected : "transparent",
  outline: isSelected ? `2px solid ${theme.accent}` : "none",
  transition: "background-color 0.15s",
});

export const getListItemStyles = (theme: Theme, isSelected: boolean) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "8px 16px",
  margin: "2px clamp(8px, 3vw, 46px)",
  borderRadius: "6px",
  cursor: "pointer",
  backgroundColor: isSelected ? theme.selected : "transparent",
  outline: isSelected ? `2px solid ${theme.accent}` : "none",
  transition: "background-color 0.15s",
});

export const getItemNameStyles = (theme: Theme) => ({
  color: theme.text,
  display: "block",
  marginTop: "8px",
  fontSize: "12px",
  wordBreak: "break-word" as const,
});

export const getListItemNameStyles = (theme: Theme) => ({
  color: theme.text,
  fontSize: "14px",
});

export const getPathItemStyles = (theme: Theme) => ({
  color: theme.accent,
  cursor: "pointer",
});
